module.exports = __webpack_public_path__ + "static/media/matching_invite_desktop.b3d4679e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/themeListing/matching_invite_desktop.jpg
// module id = 1501
// module chunks = 44